<template>
<div>
    <Spinner v-if="!loaded" />
    <div class="table-responsive" v-else>
        <vue-good-table
            mode="remote"
            :columns="columns"
            :rows="rows"
            :total-rows="totalRows"
            :pagination-options="paginationOptions"
            @page-change="onPageChange"
            @per-page-change="onPerPageChange"
        >
            <template #table-row="props">
                <span v-if="props.column.field === 'id'">
                    <router-link :to="{ name: 'Invoice', params: { id: props.row.id }}" target="_blank">{{ props.row.id }}</router-link>
                </span>
                <span v-else-if="props.column.field === 'amount'">
                    {{ props.row.currency__symbol }}{{ props.row.amount }}
                </span>
                <span v-else-if="props.column.field === 'state'">
                    <span :class="props.row.is_success ? 'badge bg-success' : 'badge bg-danger'" :title="props.row.error_message">
                        {{ props.row.is_success ? 'Success' : 'Failed' }}
                    </span>
                </span>
                <span v-else-if="props.column.field === 'external_id'">
                    <a :href="`https://tronscan.org/#/transaction/${props.row.external_id}`" v-if="props.row.system__name && props.row.system__name.indexOf('Tron') == 0" target="_blank">{{ props.row.external_id }}</a>
                    <a :href="`https://etherscan.io/tx/${props.row.external_id}`" v-else-if="props.row.system__name && props.row.system__name.indexOf('Ethereum') == 0" target="_blank">{{ props.row.external_id }}</a>
                    <a :href="`https://bscscan.com/tx/${props.row.external_id}`" v-else-if="props.row.system__name && props.row.system__name.indexOf('BSC') == 0" target="_blank">{{ props.row.external_id }}</a>
                    <span v-else>{{ props.row.external_id }}</span>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</div>
</template>

<script>
import Spinner from "../Spinner.vue"
import { toDateTime } from "utils/date";

export default {
    components: {
        Spinner,
    },
    data() {
        return {
            loaded: false,
            columns: [
                { label: "ID", field: "id", sortable: false },
                { label: "Date", field: "paid_at", formatFn: toDateTime, sortable: false },
                { label: "Amount", field: "amount", sortable: false },
                { label: "System", field: "system__name", sortable: false },
                { label: "State", field: "state", sortable: false },
                { label: "Order ID", field: "external_id", sortable: false },
            ],
            rows: [],
            totalRows: 0,
            serverParams: {
                page: 1,
                per_page: 50,
            },
        }
    },
    computed: {
        paginationOptions() {
            return {
                enabled: true,
                mode: 'pages',
                perPage: this.serverParams.per_page,
                perPageDropdown: [50, 100, 250, 500, 1000],
                dropdownAllowAll: false,
            }
        },
    },
    methods: {
        fetch() {
            this.$services.Payment().get(this.serverParams).then(resp => {
                this.rows = resp.body.data || [];
                this.totalRows = resp.body.links?.pagination?.total || 0;
            }).finally(() => {
                this.loaded = true
            })
        },
        onPageChange(params) {
            this.serverParams.page = params.currentPage;
            this.fetch();
        },
        onPerPageChange(params) {
            this.serverParams.per_page = params.currentPerPage;
            this.serverParams.page = 1;
            this.fetch();
        }
    },
    created() {
        this.fetch()
    }
}
</script>
